const raw = (process.env.REACT_APP_API_BASE_URL || "").trim();

// In prod build it must be present; fallback is just safety.
const API_BASE_URL = raw || "https://api.wayroot.com";

export default API_BASE_URL;